(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  // Eigenstaendiger Header-Switcher; Footer-/andere localization-form-Elemente bleiben unberuehrt.
  if (!customElements.get('terra-header-language')) {
    class TerraHeaderLanguage extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.button = this.querySelector('.header__locale-button');
        this.panel = this.querySelector('.header__locale-panel');
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="language_code"]');
        this.options = Array.from(this.querySelectorAll('.header__locale-option'));
        if (!this.button || !this.panel || !this.form || !this.input) return;
        this.initialized = true;
        this.input.disabled = false;
        this.onToggle = this.onToggle.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onOutsideClick = this.onOutsideClick.bind(this);
        this.button.addEventListener('click', this.onToggle);
        this.addEventListener('keydown', this.onKeyDown);
        this.addEventListener('focusout', this.onFocusOut);
        this.options.forEach(option => option.addEventListener('click', this.onOptionClick));
        document.addEventListener('pointerdown', this.onOutsideClick);
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        this.button.removeEventListener('click', this.onToggle);
        this.removeEventListener('keydown', this.onKeyDown);
        this.removeEventListener('focusout', this.onFocusOut);
        this.options.forEach(option => option.removeEventListener('click', this.onOptionClick));
        document.removeEventListener('pointerdown', this.onOutsideClick);
        this.initialized = false;
      }

      get isOpen() {
        return !this.panel.hidden;
      }

      open(focusOption = false) {
        this.panel.hidden = false;
        this.button.setAttribute('aria-expanded', 'true');
        if (focusOption && this.options.length) {
          const active = this.options.find(option => option.hasAttribute('aria-current'));
          (active || this.options[0]).focus();
        }
      }

      close(restoreFocus = false) {
        this.panel.hidden = true;
        this.button.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.button.focus();
      }

      onToggle() {
        if (this.isOpen) this.close();
        else this.open(false);
      }

      onOptionClick(event) {
        const next = event.currentTarget.dataset.value;
        if (!next) return;
        if (next === this.input.value) {
          this.close(true);
          return;
        }
        this.input.value = next;
        if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit();
        else this.form.submit();
      }

      onOutsideClick(event) {
        if (!this.contains(event.target) && this.isOpen) this.close();
      }

      onFocusOut(event) {
        if (this.isOpen && event.relatedTarget && !this.contains(event.relatedTarget)) {
          this.close();
        }
      }

      onKeyDown(event) {
        if (event.key === 'Escape' && this.isOpen) {
          event.preventDefault();
          this.close(true);
          return;
        }
        if (!this.isOpen && event.target === this.button &&
            (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
          event.preventDefault();
          this.open(false);
          const option = event.key === 'ArrowDown' ? this.options[0] : this.options[this.options.length - 1];
          if (option) option.focus();
          return;
        }
        if (!this.isOpen || !this.options.includes(event.target)) return;
        const index = this.options.indexOf(event.target);
        let nextIndex = index;
        if (event.key === 'ArrowDown') nextIndex = (index + 1) % this.options.length;
        else if (event.key === 'ArrowUp') nextIndex = (index - 1 + this.options.length) % this.options.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.options.length - 1;
        else return;
        event.preventDefault();
        this.options[nextIndex].focus();
      }
    }
    customElements.define('terra-header-language', TerraHeaderLanguage);
  }

  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('ul'),
        };

        if (!this.elements.input || !this.elements.button || !this.elements.panel) return;

        this.hidePanel = this.hidePanel.bind(this);
        this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);

        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp);
        this.querySelectorAll('a[data-value]').forEach((item) => item.addEventListener('click', this.onItemClick));
        document.addEventListener('click', this.handleDocumentClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleDocumentClick);
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';

        if (event.relatedTarget === null || shouldClose) {
          this.hidePanel();
        }
      }

      handleDocumentClick(event) {
        if (!this.contains(event.target)) {
          this.hidePanel();
        }
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();
})();
